(function () {
    'use strict';

    function dashboardFeaturesDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/dashboardfeatures';

        function loadDashboardFeatures() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        }

        return {
            loadDashboardFeatures: loadDashboardFeatures
        }
    }

    dashboardFeaturesDataService.$inject = ['$http'];

    angular.module('ecap.common').service('dashboardFeaturesDataService', dashboardFeaturesDataService);
})();